module.exports = __webpack_public_path__ + "media/images/products-img-03-43520078d7751d9fc18517e2f2d480c2.jpg";